import { render, staticRenderFns } from "./Impayes.vue?vue&type=template&id=3668688a&"
import script from "./Impayes.vue?vue&type=script&lang=js&"
export * from "./Impayes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports